export default {
    "components": [
        {
            "label": "Columns",
            "columns": [
                {
                    "components": [
                        {
                            "label": "First Name",
                            "labelPosition": "top",
                            "placeholder": "",
                            "description": "",
                            "tooltip": "",
                            "prefix": "",
                            "suffix": "",
                            "widget": {
                                "type": "input"
                            },
                            "inputMask": "",
                            "allowMultipleMasks": false,
                            "customClass": "",
                            "tabindex": "",
                            "autocomplete": "",
                            "hidden": false,
                            "hideLabel": false,
                            "showWordCount": false,
                            "showCharCount": false,
                            "mask": false,
                            "autofocus": false,
                            "spellcheck": true,
                            "disabled": false,
                            "tableView": true,
                            "modalEdit": false,
                            "multiple": false,
                            "persistent": true,
                            "inputFormat": "plain",
                            "protected": false,
                            "dbIndex": false,
                            "case": "",
                            "encrypted": false,
                            "redrawOn": "",
                            "clearOnHide": true,
                            "customDefaultValue": "",
                            "calculateValue": "",
                            "calculateServer": false,
                            "allowCalculateOverride": false,
                            "validateOn": "change",
                            "validate": {
                                "required": true,
                                "pattern": "",
                                "customMessage": "",
                                "custom": "",
                                "customPrivate": false,
                                "json": "",
                                "minLength": "",
                                "maxLength": "",
                                "strictDateValidation": false,
                                "multiple": false,
                                "unique": false
                            },
                            "unique": false,
                            "errorLabel": "",
                            "key": "firstName",
                            "tags": [],
                            "properties": {},
                            "conditional": {
                                "show": null,
                                "when": null,
                                "eq": "",
                                "json": ""
                            },
                            "customConditional": "",
                            "logic": [],
                            "attributes": {},
                            "overlay": {
                                "style": "",
                                "page": "",
                                "left": "",
                                "top": "",
                                "width": "",
                                "height": ""
                            },
                            "type": "textfield",
                            "input": true,
                            "refreshOn": "",
                            "dataGridLabel": false,
                            "inputType": "text",
                            "id": "e3qo2hv",
                            "defaultValue": ""
                        }
                    ],
                    "width": 6,
                    "offset": 0,
                    "push": 0,
                    "pull": 0,
                    "size": "md",
                    "currentWidth": 6
                },
                {
                    "components": [
                        {
                            "label": "Last Name",
                            "labelPosition": "top",
                            "placeholder": "",
                            "description": "",
                            "tooltip": "",
                            "prefix": "",
                            "suffix": "",
                            "widget": {
                                "type": "input"
                            },
                            "inputMask": "",
                            "allowMultipleMasks": false,
                            "customClass": "",
                            "tabindex": "",
                            "autocomplete": "",
                            "hidden": false,
                            "hideLabel": false,
                            "showWordCount": false,
                            "showCharCount": false,
                            "mask": false,
                            "autofocus": false,
                            "spellcheck": true,
                            "disabled": false,
                            "tableView": true,
                            "modalEdit": false,
                            "multiple": false,
                            "persistent": true,
                            "inputFormat": "plain",
                            "protected": false,
                            "dbIndex": false,
                            "case": "",
                            "encrypted": false,
                            "redrawOn": "",
                            "clearOnHide": true,
                            "customDefaultValue": "",
                            "calculateValue": "",
                            "calculateServer": false,
                            "allowCalculateOverride": false,
                            "validateOn": "change",
                            "validate": {
                                "required": true,
                                "pattern": "",
                                "customMessage": "",
                                "custom": "",
                                "customPrivate": false,
                                "json": "",
                                "minLength": "",
                                "maxLength": "",
                                "strictDateValidation": false,
                                "multiple": false,
                                "unique": false
                            },
                            "unique": false,
                            "errorLabel": "",
                            "key": "lastName",
                            "tags": [],
                            "properties": {},
                            "conditional": {
                                "show": null,
                                "when": null,
                                "eq": "",
                                "json": ""
                            },
                            "customConditional": "",
                            "logic": [],
                            "attributes": {},
                            "overlay": {
                                "style": "",
                                "page": "",
                                "left": "",
                                "top": "",
                                "width": "",
                                "height": ""
                            },
                            "type": "textfield",
                            "input": true,
                            "refreshOn": "",
                            "dataGridLabel": false,
                            "inputType": "text",
                            "id": "e02gxuq",
                            "defaultValue": ""
                        }
                    ],
                    "width": 6,
                    "offset": 0,
                    "push": 0,
                    "pull": 0,
                    "size": "md",
                    "currentWidth": 6
                }
            ],
            "autoAdjust": false,
            "customClass": "",
            "hidden": false,
            "hideLabel": false,
            "modalEdit": false,
            "key": "columns",
            "tags": [],
            "properties": {},
            "conditional": {
                "show": null,
                "when": null,
                "eq": "",
                "json": ""
            },
            "customConditional": "",
            "logic": [],
            "attributes": {},
            "overlay": {
                "style": "",
                "page": "",
                "left": "",
                "top": "",
                "width": "",
                "height": ""
            },
            "type": "columns",
            "input": false,
            "placeholder": "",
            "prefix": "",
            "suffix": "",
            "multiple": false,
            "defaultValue": null,
            "protected": false,
            "unique": false,
            "persistent": false,
            "clearOnHide": false,
            "refreshOn": "",
            "redrawOn": "",
            "tableView": false,
            "dataGridLabel": false,
            "labelPosition": "top",
            "description": "",
            "errorLabel": "",
            "tooltip": "",
            "tabindex": "",
            "disabled": false,
            "autofocus": false,
            "dbIndex": false,
            "customDefaultValue": "",
            "calculateValue": "",
            "calculateServer": false,
            "widget": null,
            "validateOn": "change",
            "validate": {
                "required": false,
                "custom": "",
                "customPrivate": false,
                "strictDateValidation": false,
                "multiple": false,
                "unique": false
            },
            "allowCalculateOverride": false,
            "encrypted": false,
            "showCharCount": false,
            "showWordCount": false,
            "allowMultipleMasks": false,
            "tree": false,
            "id": "ed56sj3"
        },
        {
            "label": "Email Address",
            "labelPosition": "top",
            "placeholder": "",
            "description": "",
            "tooltip": "",
            "prefix": "",
            "suffix": "",
            "widget": {
                "type": "input"
            },
            "inputMask": "",
            "allowMultipleMasks": false,
            "customClass": "",
            "tabindex": "",
            "autocomplete": "",
            "hidden": false,
            "hideLabel": false,
            "showWordCount": false,
            "showCharCount": false,
            "mask": false,
            "autofocus": false,
            "spellcheck": true,
            "disabled": false,
            "tableView": true,
            "modalEdit": false,
            "multiple": false,
            "persistent": true,
            "inputFormat": "plain",
            "protected": false,
            "dbIndex": false,
            "case": "",
            "encrypted": false,
            "redrawOn": "",
            "clearOnHide": true,
            "customDefaultValue": "",
            "calculateValue": "",
            "calculateServer": false,
            "allowCalculateOverride": false,
            "validateOn": "change",
            "validate": {
                "required": true,
                "pattern": "",
                "customMessage": "",
                "custom": "",
                "customPrivate": false,
                "json": "",
                "minLength": "",
                "maxLength": "",
                "strictDateValidation": false,
                "multiple": false,
                "unique": false
            },
            "unique": false,
            "errorLabel": "",
            "key": "emailAddress",
            "tags": [],
            "properties": {},
            "conditional": {
                "show": null,
                "when": null,
                "eq": "",
                "json": ""
            },
            "customConditional": "",
            "logic": [],
            "attributes": {},
            "overlay": {
                "style": "",
                "page": "",
                "left": "",
                "top": "",
                "width": "",
                "height": ""
            },
            "type": "textfield",
            "input": true,
            "refreshOn": "",
            "dataGridLabel": false,
            "inputType": "text",
            "id": "exfvl9n",
            "defaultValue": ""
        },
        {
            "label": "What Best Describes You?",
            "labelPosition": "top",
            "widget": "choicesjs",
            "placeholder": "",
            "description": "",
            "tooltip": "",
            "customClass": "",
            "tabindex": "",
            "hidden": false,
            "hideLabel": false,
            "uniqueOptions": false,
            "autofocus": false,
            "disabled": false,
            "tableView": true,
            "modalEdit": false,
            "multiple": false,
            "dataSrc": "values",
            "data": {
                "values": [
                    {
                        "label": "",
                        "value": ""
                    }
                ],
                "resource": "",
                "json": "",
                "url": "",
                "custom": ""
            },
            "dataType": "",
            "idPath": "id",
            "valueProperty": "",
            "template": "<span>{{ item.label }}</span>",
            "refreshOn": "",
            "refreshOnBlur": "",
            "clearOnRefresh": false,
            "searchEnabled": true,
            "selectThreshold": 0.3,
            "readOnlyValue": false,
            "customOptions": {},
            "useExactSearch": false,
            "persistent": true,
            "protected": false,
            "dbIndex": false,
            "encrypted": false,
            "clearOnHide": true,
            "customDefaultValue": "",
            "calculateValue": "",
            "calculateServer": false,
            "allowCalculateOverride": false,
            "validateOn": "change",
            "validate": {
                "required": false,
                "onlyAvailableItems": false,
                "customMessage": "",
                "custom": "",
                "customPrivate": false,
                "json": "",
                "strictDateValidation": false,
                "multiple": false,
                "unique": false
            },
            "unique": false,
            "errorLabel": "",
            "key": "whatBestDescribesYou",
            "tags": [],
            "properties": {},
            "conditional": {
                "show": null,
                "when": null,
                "eq": "",
                "json": ""
            },
            "customConditional": "",
            "logic": [],
            "attributes": {},
            "overlay": {
                "style": "",
                "page": "",
                "left": "",
                "top": "",
                "width": "",
                "height": ""
            },
            "type": "select",
            "indexeddb": {
                "filter": {}
            },
            "selectFields": "",
            "searchField": "",
            "minSearch": 0,
            "filter": "",
            "limit": 100,
            "redrawOn": "",
            "input": true,
            "prefix": "",
            "suffix": "",
            "dataGridLabel": false,
            "showCharCount": false,
            "showWordCount": false,
            "allowMultipleMasks": false,
            "lazyLoad": true,
            "authenticate": false,
            "ignoreCache": false,
            "searchThreshold": 0.3,
            "fuseOptions": {
                "include": "score",
                "threshold": 0.3
            },
            "id": "eu85ea",
            "defaultValue": ""
        },
        {
            "label": "Password",
            "labelPosition": "top",
            "placeholder": "",
            "description": "",
            "tooltip": "",
            "prefix": "",
            "suffix": "",
            "widget": {
                "type": "input"
            },
            "inputMask": "",
            "allowMultipleMasks": false,
            "customClass": "",
            "tabindex": "",
            "autocomplete": "",
            "hidden": false,
            "hideLabel": false,
            "showWordCount": false,
            "showCharCount": false,
            "mask": false,
            "autofocus": false,
            "spellcheck": true,
            "disabled": false,
            "tableView": true,
            "modalEdit": false,
            "multiple": false,
            "persistent": true,
            "inputFormat": "plain",
            "protected": false,
            "dbIndex": false,
            "case": "",
            "encrypted": false,
            "redrawOn": "",
            "clearOnHide": true,
            "customDefaultValue": "",
            "calculateValue": "",
            "calculateServer": false,
            "allowCalculateOverride": false,
            "validateOn": "change",
            "validate": {
                "required": true,
                "pattern": "",
                "customMessage": "",
                "custom": "",
                "customPrivate": false,
                "json": "",
                "minLength": "",
                "maxLength": "",
                "strictDateValidation": false,
                "multiple": false,
                "unique": false
            },
            "unique": false,
            "errorLabel": "",
            "key": "password",
            "tags": [],
            "properties": {},
            "conditional": {
                "show": null,
                "when": null,
                "eq": "",
                "json": ""
            },
            "customConditional": "",
            "logic": [],
            "attributes": {},
            "overlay": {
                "style": "",
                "page": "",
                "left": "",
                "top": "",
                "width": "",
                "height": ""
            },
            "type": "textfield",
            "input": true,
            "refreshOn": "",
            "dataGridLabel": false,
            "inputType": "text",
            "id": "eh0yw6mj",
            "defaultValue": ""
        },
        {
            "label": "Confirm Password",
            "labelPosition": "top",
            "placeholder": "",
            "description": "",
            "tooltip": "",
            "prefix": "",
            "suffix": "",
            "widget": {
                "type": "input"
            },
            "inputMask": "",
            "allowMultipleMasks": false,
            "customClass": "",
            "tabindex": "",
            "autocomplete": "",
            "hidden": false,
            "hideLabel": false,
            "showWordCount": false,
            "showCharCount": false,
            "mask": false,
            "autofocus": false,
            "spellcheck": true,
            "disabled": false,
            "tableView": true,
            "modalEdit": false,
            "multiple": false,
            "persistent": true,
            "inputFormat": "plain",
            "protected": false,
            "dbIndex": false,
            "case": "",
            "encrypted": false,
            "redrawOn": "",
            "clearOnHide": true,
            "customDefaultValue": "",
            "calculateValue": "",
            "calculateServer": false,
            "allowCalculateOverride": false,
            "validateOn": "change",
            "validate": {
                "required": true,
                "pattern": "",
                "customMessage": "",
                "custom": "",
                "customPrivate": false,
                "json": "",
                "minLength": "",
                "maxLength": "",
                "strictDateValidation": false,
                "multiple": false,
                "unique": false
            },
            "unique": false,
            "errorLabel": "",
            "key": "confirmPassword",
            "tags": [],
            "properties": {},
            "conditional": {
                "show": null,
                "when": null,
                "eq": "",
                "json": ""
            },
            "customConditional": "",
            "logic": [],
            "attributes": {},
            "overlay": {
                "style": "",
                "page": "",
                "left": "",
                "top": "",
                "width": "",
                "height": ""
            },
            "type": "textfield",
            "input": true,
            "refreshOn": "",
            "dataGridLabel": false,
            "inputType": "text",
            "id": "ec4vvq8",
            "defaultValue": ""
        },
        {
            "label": "I want to sign up for your Newsletter and receive marketing emails.",
            "description": "",
            "tooltip": "",
            "shortcut": "",
            "inputType": "checkbox",
            "customClass": "",
            "tabindex": "",
            "hidden": false,
            "hideLabel": false,
            "autofocus": false,
            "disabled": false,
            "tableView": false,
            "modalEdit": false,
            "persistent": true,
            "protected": false,
            "dbIndex": false,
            "encrypted": false,
            "redrawOn": "",
            "clearOnHide": true,
            "customDefaultValue": "",
            "calculateValue": "",
            "calculateServer": false,
            "allowCalculateOverride": false,
            "validate": {
                "required": false,
                "customMessage": "",
                "custom": "",
                "customPrivate": false,
                "json": "",
                "strictDateValidation": false,
                "multiple": false,
                "unique": false
            },
            "errorLabel": "",
            "key": "iWantToSignUpForBernhardtNewsletterAndReceiveMarketingEmails",
            "tags": [],
            "properties": {},
            "conditional": {
                "show": null,
                "when": null,
                "eq": "",
                "json": ""
            },
            "customConditional": "",
            "logic": [],
            "attributes": {},
            "overlay": {
                "style": "",
                "page": "",
                "left": "",
                "top": "",
                "width": "",
                "height": ""
            },
            "type": "checkbox",
            "name": "",
            "value": "",
            "input": true,
            "placeholder": "",
            "prefix": "",
            "suffix": "",
            "multiple": false,
            "unique": false,
            "refreshOn": "",
            "dataGridLabel": true,
            "labelPosition": "right",
            "widget": null,
            "validateOn": "change",
            "showCharCount": false,
            "showWordCount": false,
            "allowMultipleMasks": false,
            "id": "eyx1j3i",
            "defaultValue": false
        },
        {
            "label": "Create Account",
            "action": "submit",
            "showValidations": false,
            "theme": "primary",
            "size": "md",
            "block": false,
            "leftIcon": "",
            "rightIcon": "",
            "shortcut": "",
            "description": "",
            "tooltip": "",
            "customClass": "",
            "tabindex": "",
            "disableOnInvalid": true,
            "hidden": false,
            "autofocus": false,
            "disabled": false,
            "tableView": false,
            "modalEdit": false,
            "key": "submit",
            "tags": [],
            "properties": {},
            "conditional": {
                "show": null,
                "when": null,
                "eq": "",
                "json": ""
            },
            "customConditional": "",
            "logic": [],
            "attributes": {},
            "overlay": {
                "style": "",
                "page": "",
                "left": "",
                "top": "",
                "width": "",
                "height": ""
            },
            "type": "button",
            "input": true,
            "placeholder": "",
            "prefix": "",
            "suffix": "",
            "multiple": false,
            "defaultValue": null,
            "protected": false,
            "unique": false,
            "persistent": false,
            "clearOnHide": true,
            "refreshOn": "",
            "redrawOn": "",
            "dataGridLabel": true,
            "labelPosition": "top",
            "errorLabel": "",
            "hideLabel": false,
            "dbIndex": false,
            "customDefaultValue": "",
            "calculateValue": "",
            "calculateServer": false,
            "widget": {
                "type": "input"
            },
            "validateOn": "change",
            "validate": {
                "required": false,
                "custom": "",
                "customPrivate": false,
                "strictDateValidation": false,
                "multiple": false,
                "unique": false
            },
            "allowCalculateOverride": false,
            "encrypted": false,
            "showCharCount": false,
            "showWordCount": false,
            "allowMultipleMasks": false,
            "id": "ey6qka5",
            "saveOnEnter": false
        }
    ],
    "display": "form",
    "page": 0
}